/*!
 * vue-router v4.0.12
 * (c) 2021 Eduardo San Martin Morote
 * @license MIT
 */
var VueRouter = (function (e, t) {
  "use strict";
  const n =
      "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag,
    r = (e) => (n ? Symbol(e) : "_vr_" + e),
    o = r("rvlm"),
    a = r("rvd"),
    c = r("r"),
    s = r("rl"),
    i = r("rvl"),
    l = "undefined" != typeof window;
  const u = Object.assign;
  function f(e, t) {
    const n = {};
    for (const r in t) {
      const o = t[r];
      n[r] = Array.isArray(o) ? o.map(e) : e(o);
    }
    return n;
  }
  const p = () => {},
    h = /\/$/;
  function d(e, t, n = "/") {
    let r,
      o = {},
      a = "",
      c = "";
    const s = t.indexOf("?"),
      i = t.indexOf("#", s > -1 ? s : 0);
    return (
      s > -1 &&
        ((r = t.slice(0, s)),
        (a = t.slice(s + 1, i > -1 ? i : t.length)),
        (o = e(a))),
      i > -1 && ((r = r || t.slice(0, i)), (c = t.slice(i, t.length))),
      (r = (function (e, t) {
        if (e.startsWith("/")) return e;
        if (!e) return t;
        const n = t.split("/"),
          r = e.split("/");
        let o,
          a,
          c = n.length - 1;
        for (o = 0; o < r.length; o++)
          if (((a = r[o]), 1 !== c && "." !== a)) {
            if (".." !== a) break;
            c--;
          }
        return (
          n.slice(0, c).join("/") +
          "/" +
          r.slice(o - (o === r.length ? 1 : 0)).join("/")
        );
      })(null != r ? r : t, n)),
      { fullPath: r + (a && "?") + a + c, path: r, query: o, hash: c }
    );
  }
  function m(e, t) {
    return t && e.toLowerCase().startsWith(t.toLowerCase())
      ? e.slice(t.length) || "/"
      : e;
  }
  function g(e, t) {
    return (e.aliasOf || e) === (t.aliasOf || t);
  }
  function v(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for (const n in e) if (!y(e[n], t[n])) return !1;
    return !0;
  }
  function y(e, t) {
    return Array.isArray(e) ? b(e, t) : Array.isArray(t) ? b(t, e) : e === t;
  }
  function b(e, t) {
    return Array.isArray(t)
      ? e.length === t.length && e.every((e, n) => e === t[n])
      : 1 === e.length && e[0] === t;
  }
  var w, E;
  !(function (e) {
    (e.pop = "pop"), (e.push = "push");
  })(w || (w = {})),
    (function (e) {
      (e.back = "back"), (e.forward = "forward"), (e.unknown = "");
    })(E || (E = {}));
  function R(e) {
    if (!e)
      if (l) {
        const t = document.querySelector("base");
        e = (e = (t && t.getAttribute("href")) || "/").replace(
          /^\w+:\/\/[^\/]+/,
          ""
        );
      } else e = "/";
    return "/" !== e[0] && "#" !== e[0] && (e = "/" + e), e.replace(h, "");
  }
  const A = /^[^#]+#/;
  function k(e, t) {
    return e.replace(A, "#") + t;
  }
  const O = () => ({ left: window.pageXOffset, top: window.pageYOffset });
  function P(e) {
    let t;
    if ("el" in e) {
      const n = e.el,
        r = "string" == typeof n && n.startsWith("#"),
        o =
          "string" == typeof n
            ? r
              ? document.getElementById(n.slice(1))
              : document.querySelector(n)
            : n;
      if (!o) return;
      t = (function (e, t) {
        const n = document.documentElement.getBoundingClientRect(),
          r = e.getBoundingClientRect();
        return {
          behavior: t.behavior,
          left: r.left - n.left - (t.left || 0),
          top: r.top - n.top - (t.top || 0),
        };
      })(o, e);
    } else t = e;
    "scrollBehavior" in document.documentElement.style
      ? window.scrollTo(t)
      : window.scrollTo(
          null != t.left ? t.left : window.pageXOffset,
          null != t.top ? t.top : window.pageYOffset
        );
  }
  function j(e, t) {
    return (history.state ? history.state.position - t : -1) + e;
  }
  const x = new Map();
  let C = () => location.protocol + "//" + location.host;
  function $(e, t) {
    const { pathname: n, search: r, hash: o } = t,
      a = e.indexOf("#");
    if (a > -1) {
      let t = o.includes(e.slice(a)) ? e.slice(a).length : 1,
        n = o.slice(t);
      return "/" !== n[0] && (n = "/" + n), m(n, "");
    }
    return m(n, e) + r + o;
  }
  function S(e, t, n, r = !1, o = !1) {
    return {
      back: e,
      current: t,
      forward: n,
      replaced: r,
      position: window.history.length,
      scroll: o ? O() : null,
    };
  }
  function L(e) {
    const t = (function (e) {
        const { history: t, location: n } = window,
          r = { value: $(e, n) },
          o = { value: t.state };
        function a(r, a, c) {
          const s = e.indexOf("#"),
            i =
              s > -1
                ? (n.host && document.querySelector("base") ? e : e.slice(s)) +
                  r
                : C() + e + r;
          try {
            t[c ? "replaceState" : "pushState"](a, "", i), (o.value = a);
          } catch (e) {
            console.error(e), n[c ? "replace" : "assign"](i);
          }
        }
        return (
          o.value ||
            a(
              r.value,
              {
                back: null,
                current: r.value,
                forward: null,
                position: t.length - 1,
                replaced: !0,
                scroll: null,
              },
              !0
            ),
          {
            location: r,
            state: o,
            push: function (e, n) {
              const c = u({}, o.value, t.state, { forward: e, scroll: O() });
              a(c.current, c, !0),
                a(
                  e,
                  u({}, S(r.value, e, null), { position: c.position + 1 }, n),
                  !1
                ),
                (r.value = e);
            },
            replace: function (e, n) {
              a(
                e,
                u({}, t.state, S(o.value.back, e, o.value.forward, !0), n, {
                  position: o.value.position,
                }),
                !0
              ),
                (r.value = e);
            },
          }
        );
      })((e = R(e))),
      n = (function (e, t, n, r) {
        let o = [],
          a = [],
          c = null;
        const s = ({ state: a }) => {
          const s = $(e, location),
            i = n.value,
            l = t.value;
          let u = 0;
          if (a) {
            if (((n.value = s), (t.value = a), c && c === i))
              return void (c = null);
            u = l ? a.position - l.position : 0;
          } else r(s);
          o.forEach((e) => {
            e(n.value, i, {
              delta: u,
              type: w.pop,
              direction: u ? (u > 0 ? E.forward : E.back) : E.unknown,
            });
          });
        };
        function i() {
          const { history: e } = window;
          e.state && e.replaceState(u({}, e.state, { scroll: O() }), "");
        }
        return (
          window.addEventListener("popstate", s),
          window.addEventListener("beforeunload", i),
          {
            pauseListeners: function () {
              c = n.value;
            },
            listen: function (e) {
              o.push(e);
              const t = () => {
                const t = o.indexOf(e);
                t > -1 && o.splice(t, 1);
              };
              return a.push(t), t;
            },
            destroy: function () {
              for (const e of a) e();
              (a = []),
                window.removeEventListener("popstate", s),
                window.removeEventListener("beforeunload", i);
            },
          }
        );
      })(e, t.state, t.location, t.replace);
    const r = u(
      {
        location: "",
        base: e,
        go: function (e, t = !0) {
          t || n.pauseListeners(), history.go(e);
        },
        createHref: k.bind(null, e),
      },
      t,
      n
    );
    return (
      Object.defineProperty(r, "location", {
        enumerable: !0,
        get: () => t.location.value,
      }),
      Object.defineProperty(r, "state", {
        enumerable: !0,
        get: () => t.state.value,
      }),
      r
    );
  }
  function q(e) {
    return "string" == typeof e || "symbol" == typeof e;
  }
  const M = {
      path: "/",
      name: void 0,
      params: {},
      query: {},
      hash: "",
      fullPath: "/",
      matched: [],
      meta: {},
      redirectedFrom: void 0,
    },
    _ = r("nf");
  var T;
  function B(e, t) {
    return u(new Error(), { type: e, [_]: !0 }, t);
  }
  function G(e, t) {
    return e instanceof Error && _ in e && (null == t || !!(e.type & t));
  }
  (e.NavigationFailureType = void 0),
    ((T = e.NavigationFailureType || (e.NavigationFailureType = {}))[
      (T.aborted = 4)
    ] = "aborted"),
    (T[(T.cancelled = 8)] = "cancelled"),
    (T[(T.duplicated = 16)] = "duplicated");
  const F = "[^/]+?",
    I = { sensitive: !1, strict: !1, start: !0, end: !0 },
    K = /[.+*?^${}()[\]/\\]/g;
  function U(e, t) {
    let n = 0;
    for (; n < e.length && n < t.length; ) {
      const r = t[n] - e[n];
      if (r) return r;
      n++;
    }
    return e.length < t.length
      ? 1 === e.length && 80 === e[0]
        ? -1
        : 1
      : e.length > t.length
      ? 1 === t.length && 80 === t[0]
        ? 1
        : -1
      : 0;
  }
  function V(e, t) {
    let n = 0;
    const r = e.score,
      o = t.score;
    for (; n < r.length && n < o.length; ) {
      const e = U(r[n], o[n]);
      if (e) return e;
      n++;
    }
    return o.length - r.length;
  }
  const H = { type: 0, value: "" },
    W = /[a-zA-Z0-9_]/;
  function D(e, t, n) {
    const r = (function (e, t) {
        const n = u({}, I, t),
          r = [];
        let o = n.start ? "^" : "";
        const a = [];
        for (const t of e) {
          const e = t.length ? [] : [90];
          n.strict && !t.length && (o += "/");
          for (let r = 0; r < t.length; r++) {
            const c = t[r];
            let s = 40 + (n.sensitive ? 0.25 : 0);
            if (0 === c.type)
              r || (o += "/"), (o += c.value.replace(K, "\\$&")), (s += 40);
            else if (1 === c.type) {
              const { value: e, repeatable: n, optional: i, regexp: l } = c;
              a.push({ name: e, repeatable: n, optional: i });
              const u = l || F;
              if (u !== F) {
                s += 10;
                try {
                  new RegExp(`(${u})`);
                } catch (t) {
                  throw new Error(
                    `Invalid custom RegExp for param "${e}" (${u}): ` +
                      t.message
                  );
                }
              }
              let f = n ? `((?:${u})(?:/(?:${u}))*)` : `(${u})`;
              r || (f = i && t.length < 2 ? `(?:/${f})` : "/" + f),
                i && (f += "?"),
                (o += f),
                (s += 20),
                i && (s += -8),
                n && (s += -20),
                ".*" === u && (s += -50);
            }
            e.push(s);
          }
          r.push(e);
        }
        if (n.strict && n.end) {
          const e = r.length - 1;
          r[e][r[e].length - 1] += 0.7000000000000001;
        }
        n.strict || (o += "/?"),
          n.end ? (o += "$") : n.strict && (o += "(?:/|$)");
        const c = new RegExp(o, n.sensitive ? "" : "i");
        return {
          re: c,
          score: r,
          keys: a,
          parse: function (e) {
            const t = e.match(c),
              n = {};
            if (!t) return null;
            for (let e = 1; e < t.length; e++) {
              const r = t[e] || "",
                o = a[e - 1];
              n[o.name] = r && o.repeatable ? r.split("/") : r;
            }
            return n;
          },
          stringify: function (t) {
            let n = "",
              r = !1;
            for (const o of e) {
              (r && n.endsWith("/")) || (n += "/"), (r = !1);
              for (const e of o)
                if (0 === e.type) n += e.value;
                else if (1 === e.type) {
                  const { value: a, repeatable: c, optional: s } = e,
                    i = a in t ? t[a] : "";
                  if (Array.isArray(i) && !c)
                    throw new Error(
                      `Provided param "${a}" is an array but it is not repeatable (* or + modifiers)`
                    );
                  const l = Array.isArray(i) ? i.join("/") : i;
                  if (!l) {
                    if (!s) throw new Error(`Missing required param "${a}"`);
                    o.length < 2 &&
                      (n.endsWith("/") ? (n = n.slice(0, -1)) : (r = !0));
                  }
                  n += l;
                }
            }
            return n;
          },
        };
      })(
        (function (e) {
          if (!e) return [[]];
          if ("/" === e) return [[H]];
          if (!e.startsWith("/")) throw new Error(`Invalid path "${e}"`);
          function t(e) {
            throw new Error(`ERR (${n})/"${l}": ${e}`);
          }
          let n = 0,
            r = n;
          const o = [];
          let a;
          function c() {
            a && o.push(a), (a = []);
          }
          let s,
            i = 0,
            l = "",
            u = "";
          function f() {
            l &&
              (0 === n
                ? a.push({ type: 0, value: l })
                : 1 === n || 2 === n || 3 === n
                ? (a.length > 1 &&
                    ("*" === s || "+" === s) &&
                    t(
                      `A repeatable param (${l}) must be alone in its segment. eg: '/:ids+.`
                    ),
                  a.push({
                    type: 1,
                    value: l,
                    regexp: u,
                    repeatable: "*" === s || "+" === s,
                    optional: "*" === s || "?" === s,
                  }))
                : t("Invalid state to consume buffer"),
              (l = ""));
          }
          function p() {
            l += s;
          }
          for (; i < e.length; )
            if (((s = e[i++]), "\\" !== s || 2 === n))
              switch (n) {
                case 0:
                  "/" === s
                    ? (l && f(), c())
                    : ":" === s
                    ? (f(), (n = 1))
                    : p();
                  break;
                case 4:
                  p(), (n = r);
                  break;
                case 1:
                  "(" === s
                    ? (n = 2)
                    : W.test(s)
                    ? p()
                    : (f(),
                      (n = 0),
                      "*" !== s && "?" !== s && "+" !== s && i--);
                  break;
                case 2:
                  ")" === s
                    ? "\\" == u[u.length - 1]
                      ? (u = u.slice(0, -1) + s)
                      : (n = 3)
                    : (u += s);
                  break;
                case 3:
                  f(),
                    (n = 0),
                    "*" !== s && "?" !== s && "+" !== s && i--,
                    (u = "");
                  break;
                default:
                  t("Unknown state");
              }
            else (r = n), (n = 4);
          return (
            2 === n && t(`Unfinished custom RegExp for param "${l}"`),
            f(),
            c(),
            o
          );
        })(e.path),
        n
      ),
      o = u(r, { record: e, parent: t, children: [], alias: [] });
    return t && !o.record.aliasOf == !t.record.aliasOf && t.children.push(o), o;
  }
  function N(e, t) {
    const n = [],
      r = new Map();
    function o(e, n, r) {
      const s = !r,
        i = (function (e) {
          return {
            path: e.path,
            redirect: e.redirect,
            name: e.name,
            meta: e.meta || {},
            aliasOf: void 0,
            beforeEnter: e.beforeEnter,
            props: z(e),
            children: e.children || [],
            instances: {},
            leaveGuards: new Set(),
            updateGuards: new Set(),
            enterCallbacks: {},
            components:
              "components" in e ? e.components || {} : { default: e.component },
          };
        })(e);
      i.aliasOf = r && r.record;
      const l = Y(t, e),
        f = [i];
      if ("alias" in e) {
        const t = "string" == typeof e.alias ? [e.alias] : e.alias;
        for (const e of t)
          f.push(
            u({}, i, {
              components: r ? r.record.components : i.components,
              path: e,
              aliasOf: r ? r.record : i,
            })
          );
      }
      let h, d;
      for (const t of f) {
        const { path: u } = t;
        if (n && "/" !== u[0]) {
          const e = n.record.path,
            r = "/" === e[e.length - 1] ? "" : "/";
          t.path = n.record.path + (u && r + u);
        }
        if (
          ((h = D(t, n, l)),
          r
            ? r.alias.push(h)
            : ((d = d || h),
              d !== h && d.alias.push(h),
              s && e.name && !Q(h) && a(e.name)),
          "children" in i)
        ) {
          const e = i.children;
          for (let t = 0; t < e.length; t++) o(e[t], h, r && r.children[t]);
        }
        (r = r || h), c(h);
      }
      return d
        ? () => {
            a(d);
          }
        : p;
    }
    function a(e) {
      if (q(e)) {
        const t = r.get(e);
        t &&
          (r.delete(e),
          n.splice(n.indexOf(t), 1),
          t.children.forEach(a),
          t.alias.forEach(a));
      } else {
        const t = n.indexOf(e);
        t > -1 &&
          (n.splice(t, 1),
          e.record.name && r.delete(e.record.name),
          e.children.forEach(a),
          e.alias.forEach(a));
      }
    }
    function c(e) {
      let t = 0;
      for (; t < n.length && V(e, n[t]) >= 0; ) t++;
      n.splice(t, 0, e), e.record.name && !Q(e) && r.set(e.record.name, e);
    }
    return (
      (t = Y({ strict: !1, end: !0, sensitive: !1 }, t)),
      e.forEach((e) => o(e)),
      {
        addRoute: o,
        resolve: function (e, t) {
          let o,
            a,
            c,
            s = {};
          if ("name" in e && e.name) {
            if (((o = r.get(e.name)), !o)) throw B(1, { location: e });
            (c = o.record.name),
              (s = u(
                (function (e, t) {
                  const n = {};
                  for (const r of t) r in e && (n[r] = e[r]);
                  return n;
                })(
                  t.params,
                  o.keys.filter((e) => !e.optional).map((e) => e.name)
                ),
                e.params
              )),
              (a = o.stringify(s));
          } else if ("path" in e)
            (a = e.path),
              (o = n.find((e) => e.re.test(a))),
              o && ((s = o.parse(a)), (c = o.record.name));
          else {
            if (
              ((o = t.name ? r.get(t.name) : n.find((e) => e.re.test(t.path))),
              !o)
            )
              throw B(1, { location: e, currentLocation: t });
            (c = o.record.name),
              (s = u({}, t.params, e.params)),
              (a = o.stringify(s));
          }
          const i = [];
          let l = o;
          for (; l; ) i.unshift(l.record), (l = l.parent);
          return { name: c, path: a, params: s, matched: i, meta: X(i) };
        },
        removeRoute: a,
        getRoutes: function () {
          return n;
        },
        getRecordMatcher: function (e) {
          return r.get(e);
        },
      }
    );
  }
  function z(e) {
    const t = {},
      n = e.props || !1;
    if ("component" in e) t.default = n;
    else for (const r in e.components) t[r] = "boolean" == typeof n ? n : n[r];
    return t;
  }
  function Q(e) {
    for (; e; ) {
      if (e.record.aliasOf) return !0;
      e = e.parent;
    }
    return !1;
  }
  function X(e) {
    return e.reduce((e, t) => u(e, t.meta), {});
  }
  function Y(e, t) {
    const n = {};
    for (const r in e) n[r] = r in t ? t[r] : e[r];
    return n;
  }
  const Z = /#/g,
    J = /&/g,
    ee = /\//g,
    te = /=/g,
    ne = /\?/g,
    re = /\+/g,
    oe = /%5B/g,
    ae = /%5D/g,
    ce = /%5E/g,
    se = /%60/g,
    ie = /%7B/g,
    le = /%7C/g,
    ue = /%7D/g,
    fe = /%20/g;
  function pe(e) {
    return encodeURI("" + e)
      .replace(le, "|")
      .replace(oe, "[")
      .replace(ae, "]");
  }
  function he(e) {
    return pe(e)
      .replace(re, "%2B")
      .replace(fe, "+")
      .replace(Z, "%23")
      .replace(J, "%26")
      .replace(se, "`")
      .replace(ie, "{")
      .replace(ue, "}")
      .replace(ce, "^");
  }
  function de(e) {
    return null == e
      ? ""
      : (function (e) {
          return pe(e).replace(Z, "%23").replace(ne, "%3F");
        })(e).replace(ee, "%2F");
  }
  function me(e) {
    try {
      return decodeURIComponent("" + e);
    } catch (e) {}
    return "" + e;
  }
  function ge(e) {
    const t = {};
    if ("" === e || "?" === e) return t;
    const n = ("?" === e[0] ? e.slice(1) : e).split("&");
    for (let e = 0; e < n.length; ++e) {
      const r = n[e].replace(re, " "),
        o = r.indexOf("="),
        a = me(o < 0 ? r : r.slice(0, o)),
        c = o < 0 ? null : me(r.slice(o + 1));
      if (a in t) {
        let e = t[a];
        Array.isArray(e) || (e = t[a] = [e]), e.push(c);
      } else t[a] = c;
    }
    return t;
  }
  function ve(e) {
    let t = "";
    for (let n in e) {
      const r = e[n];
      if (((n = he(n).replace(te, "%3D")), null == r)) {
        void 0 !== r && (t += (t.length ? "&" : "") + n);
        continue;
      }
      (Array.isArray(r) ? r.map((e) => e && he(e)) : [r && he(r)]).forEach(
        (e) => {
          void 0 !== e &&
            ((t += (t.length ? "&" : "") + n), null != e && (t += "=" + e));
        }
      );
    }
    return t;
  }
  function ye(e) {
    const t = {};
    for (const n in e) {
      const r = e[n];
      void 0 !== r &&
        (t[n] = Array.isArray(r)
          ? r.map((e) => (null == e ? null : "" + e))
          : null == r
          ? r
          : "" + r);
    }
    return t;
  }
  function be() {
    let e = [];
    return {
      add: function (t) {
        return (
          e.push(t),
          () => {
            const n = e.indexOf(t);
            n > -1 && e.splice(n, 1);
          }
        );
      },
      list: () => e,
      reset: function () {
        e = [];
      },
    };
  }
  function we(e, n, r) {
    const o = () => {
      e[n].delete(r);
    };
    t.onUnmounted(o),
      t.onDeactivated(o),
      t.onActivated(() => {
        e[n].add(r);
      }),
      e[n].add(r);
  }
  function Ee(e, t, n, r, o) {
    const a = r && (r.enterCallbacks[o] = r.enterCallbacks[o] || []);
    return () =>
      new Promise((c, s) => {
        const i = (e) => {
            var i;
            !1 === e
              ? s(B(4, { from: n, to: t }))
              : e instanceof Error
              ? s(e)
              : "string" == typeof (i = e) || (i && "object" == typeof i)
              ? s(B(2, { from: t, to: e }))
              : (a &&
                  r.enterCallbacks[o] === a &&
                  "function" == typeof e &&
                  a.push(e),
                c());
          },
          l = e.call(r && r.instances[o], t, n, i);
        let u = Promise.resolve(l);
        e.length < 3 && (u = u.then(i)), u.catch((e) => s(e));
      });
  }
  function Re(e, t, r, o) {
    const a = [];
    for (const s of e)
      for (const e in s.components) {
        let i = s.components[e];
        if ("beforeRouteEnter" === t || s.instances[e])
          if (
            "object" == typeof (c = i) ||
            "displayName" in c ||
            "props" in c ||
            "__vccOpts" in c
          ) {
            const n = (i.__vccOpts || i)[t];
            n && a.push(Ee(n, r, o, s, e));
          } else {
            let c = i();
            a.push(() =>
              c.then((a) => {
                if (!a)
                  return Promise.reject(
                    new Error(
                      `Couldn't resolve component "${e}" at "${s.path}"`
                    )
                  );
                const c =
                  (i = a).__esModule ||
                  (n && "Module" === i[Symbol.toStringTag])
                    ? a.default
                    : a;
                var i;
                s.components[e] = c;
                const l = (c.__vccOpts || c)[t];
                return l && Ee(l, r, o, s, e)();
              })
            );
          }
      }
    var c;
    return a;
  }
  function Ae(e) {
    const n = t.inject(c),
      r = t.inject(s),
      o = t.computed(() => n.resolve(t.unref(e.to))),
      a = t.computed(() => {
        const { matched: e } = o.value,
          { length: t } = e,
          n = e[t - 1],
          a = r.matched;
        if (!n || !a.length) return -1;
        const c = a.findIndex(g.bind(null, n));
        if (c > -1) return c;
        const s = Oe(e[t - 2]);
        return t > 1 && Oe(n) === s && a[a.length - 1].path !== s
          ? a.findIndex(g.bind(null, e[t - 2]))
          : c;
      }),
      i = t.computed(
        () =>
          a.value > -1 &&
          (function (e, t) {
            for (const n in t) {
              const r = t[n],
                o = e[n];
              if ("string" == typeof r) {
                if (r !== o) return !1;
              } else if (
                !Array.isArray(o) ||
                o.length !== r.length ||
                r.some((e, t) => e !== o[t])
              )
                return !1;
            }
            return !0;
          })(r.params, o.value.params)
      ),
      l = t.computed(
        () =>
          a.value > -1 &&
          a.value === r.matched.length - 1 &&
          v(r.params, o.value.params)
      );
    return {
      route: o,
      href: t.computed(() => o.value.href),
      isActive: i,
      isExactActive: l,
      navigate: function (r = {}) {
        return (function (e) {
          if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
          if (e.defaultPrevented) return;
          if (void 0 !== e.button && 0 !== e.button) return;
          if (e.currentTarget && e.currentTarget.getAttribute) {
            const t = e.currentTarget.getAttribute("target");
            if (/\b_blank\b/i.test(t)) return;
          }
          e.preventDefault && e.preventDefault();
          return !0;
        })(r)
          ? n[t.unref(e.replace) ? "replace" : "push"](t.unref(e.to)).catch(p)
          : Promise.resolve();
      },
    };
  }
  const ke = t.defineComponent({
    name: "RouterLink",
    props: {
      to: { type: [String, Object], required: !0 },
      replace: Boolean,
      activeClass: String,
      exactActiveClass: String,
      custom: Boolean,
      ariaCurrentValue: { type: String, default: "page" },
    },
    useLink: Ae,
    setup(e, { slots: n }) {
      const r = t.reactive(Ae(e)),
        { options: o } = t.inject(c),
        a = t.computed(() => ({
          [Pe(e.activeClass, o.linkActiveClass, "router-link-active")]:
            r.isActive,
          [Pe(
            e.exactActiveClass,
            o.linkExactActiveClass,
            "router-link-exact-active"
          )]: r.isExactActive,
        }));
      return () => {
        const o = n.default && n.default(r);
        return e.custom
          ? o
          : t.h(
              "a",
              {
                "aria-current": r.isExactActive ? e.ariaCurrentValue : null,
                href: r.href,
                onClick: r.navigate,
                class: a.value,
              },
              o
            );
      };
    },
  });
  function Oe(e) {
    return e ? (e.aliasOf ? e.aliasOf.path : e.path) : "";
  }
  const Pe = (e, t, n) => (null != e ? e : null != t ? t : n);
  function je(e, t) {
    if (!e) return null;
    const n = e(t);
    return 1 === n.length ? n[0] : n;
  }
  const xe = t.defineComponent({
    name: "RouterView",
    inheritAttrs: !1,
    props: { name: { type: String, default: "default" }, route: Object },
    setup(e, { attrs: n, slots: r }) {
      const c = t.inject(i),
        s = t.computed(() => e.route || c.value),
        l = t.inject(a, 0),
        f = t.computed(() => s.value.matched[l]);
      t.provide(a, l + 1), t.provide(o, f), t.provide(i, s);
      const p = t.ref();
      return (
        t.watch(
          () => [p.value, f.value, e.name],
          ([e, t, n], [r, o, a]) => {
            t &&
              ((t.instances[n] = e),
              o &&
                o !== t &&
                e &&
                e === r &&
                (t.leaveGuards.size || (t.leaveGuards = o.leaveGuards),
                t.updateGuards.size || (t.updateGuards = o.updateGuards))),
              !e ||
                !t ||
                (o && g(t, o) && r) ||
                (t.enterCallbacks[n] || []).forEach((t) => t(e));
          },
          { flush: "post" }
        ),
        () => {
          const o = s.value,
            a = f.value,
            c = a && a.components[e.name],
            i = e.name;
          if (!c) return je(r.default, { Component: c, route: o });
          const l = a.props[e.name],
            h = l
              ? !0 === l
                ? o.params
                : "function" == typeof l
                ? l(o)
                : l
              : null,
            d = t.h(
              c,
              u({}, h, n, {
                onVnodeUnmounted: (e) => {
                  e.component.isUnmounted && (a.instances[i] = null);
                },
                ref: p,
              })
            );
          return je(r.default, { Component: d, route: o }) || d;
        }
      );
    },
  });
  function Ce(e) {
    return e.reduce((e, t) => e.then(() => t()), Promise.resolve());
  }
  return (
    (e.RouterLink = ke),
    (e.RouterView = xe),
    (e.START_LOCATION = M),
    (e.createMemoryHistory = function (e = "") {
      let t = [],
        n = [""],
        r = 0;
      function o(e) {
        r++, r === n.length || n.splice(r), n.push(e);
      }
      const a = {
        location: "",
        state: {},
        base: (e = R(e)),
        createHref: k.bind(null, e),
        replace(e) {
          n.splice(r--, 1), o(e);
        },
        push(e, t) {
          o(e);
        },
        listen: (e) => (
          t.push(e),
          () => {
            const n = t.indexOf(e);
            n > -1 && t.splice(n, 1);
          }
        ),
        destroy() {
          (t = []), (n = [""]), (r = 0);
        },
        go(e, o = !0) {
          const a = this.location,
            c = e < 0 ? E.back : E.forward;
          (r = Math.max(0, Math.min(r + e, n.length - 1))),
            o &&
              (function (e, n, { direction: r, delta: o }) {
                const a = { direction: r, delta: o, type: w.pop };
                for (const r of t) r(e, n, a);
              })(this.location, a, { direction: c, delta: e });
        },
      };
      return (
        Object.defineProperty(a, "location", {
          enumerable: !0,
          get: () => n[r],
        }),
        a
      );
    }),
    (e.createRouter = function (e) {
      const n = N(e.routes, e),
        r = e.parseQuery || ge,
        o = e.stringifyQuery || ve,
        a = e.history,
        h = be(),
        m = be(),
        y = be(),
        b = t.shallowRef(M);
      let E = M;
      l &&
        e.scrollBehavior &&
        "scrollRestoration" in history &&
        (history.scrollRestoration = "manual");
      const R = f.bind(null, (e) => "" + e),
        A = f.bind(null, de),
        k = f.bind(null, me);
      function C(e, t) {
        if (((t = u({}, t || b.value)), "string" == typeof e)) {
          const o = d(r, e, t.path),
            c = n.resolve({ path: o.path }, t),
            s = a.createHref(o.fullPath);
          return u(o, c, {
            params: k(c.params),
            hash: me(o.hash),
            redirectedFrom: void 0,
            href: s,
          });
        }
        let c;
        if ("path" in e) c = u({}, e, { path: d(r, e.path, t.path).path });
        else {
          const n = u({}, e.params);
          for (const e in n) null == n[e] && delete n[e];
          (c = u({}, e, { params: A(e.params) })), (t.params = A(t.params));
        }
        const s = n.resolve(c, t),
          i = e.hash || "";
        s.params = R(k(s.params));
        const l = (function (e, t) {
          const n = t.query ? e(t.query) : "";
          return t.path + (n && "?") + n + (t.hash || "");
        })(
          o,
          u({}, e, {
            hash:
              ((f = i),
              pe(f).replace(ie, "{").replace(ue, "}").replace(ce, "^")),
            path: s.path,
          })
        );
        var f;
        const p = a.createHref(l);
        return u(
          {
            fullPath: l,
            hash: i,
            query: o === ve ? ye(e.query) : e.query || {},
          },
          s,
          { redirectedFrom: void 0, href: p }
        );
      }
      function $(e) {
        return "string" == typeof e ? d(r, e, b.value.path) : u({}, e);
      }
      function S(e, t) {
        if (E !== e) return B(8, { from: t, to: e });
      }
      function L(e) {
        return T(e);
      }
      function _(e) {
        const t = e.matched[e.matched.length - 1];
        if (t && t.redirect) {
          const { redirect: n } = t;
          let r = "function" == typeof n ? n(e) : n;
          return (
            "string" == typeof r &&
              ((r =
                r.includes("?") || r.includes("#") ? (r = $(r)) : { path: r }),
              (r.params = {})),
            u({ query: e.query, hash: e.hash, params: e.params }, r)
          );
        }
      }
      function T(e, t) {
        const n = (E = C(e)),
          r = b.value,
          a = e.state,
          c = e.force,
          s = !0 === e.replace,
          i = _(n);
        if (i) return T(u($(i), { state: a, force: c, replace: s }), t || n);
        const l = n;
        let f;
        return (
          (l.redirectedFrom = t),
          !c &&
            (function (e, t, n) {
              const r = t.matched.length - 1,
                o = n.matched.length - 1;
              return (
                r > -1 &&
                r === o &&
                g(t.matched[r], n.matched[o]) &&
                v(t.params, n.params) &&
                e(t.query) === e(n.query) &&
                t.hash === n.hash
              );
            })(o, r, n) &&
            ((f = B(16, { to: l, from: r })), Y(r, r, !0, !1)),
          (f ? Promise.resolve(f) : I(l, r))
            .catch((e) => (G(e) ? e : Q(e, l, r)))
            .then((e) => {
              if (e) {
                if (G(e, 2))
                  return T(
                    u($(e.to), { state: a, force: c, replace: s }),
                    t || l
                  );
              } else e = U(l, r, !0, s, a);
              return K(l, r, e), e;
            })
        );
      }
      function F(e, t) {
        const n = S(e, t);
        return n ? Promise.reject(n) : Promise.resolve();
      }
      function I(e, t) {
        let n;
        const [r, o, a] = (function (e, t) {
          const n = [],
            r = [],
            o = [],
            a = Math.max(t.matched.length, e.matched.length);
          for (let c = 0; c < a; c++) {
            const a = t.matched[c];
            a && (e.matched.find((e) => g(e, a)) ? r.push(a) : n.push(a));
            const s = e.matched[c];
            s && (t.matched.find((e) => g(e, s)) || o.push(s));
          }
          return [n, r, o];
        })(e, t);
        n = Re(r.reverse(), "beforeRouteLeave", e, t);
        for (const o of r)
          o.leaveGuards.forEach((r) => {
            n.push(Ee(r, e, t));
          });
        const c = F.bind(null, e, t);
        return (
          n.push(c),
          Ce(n)
            .then(() => {
              n = [];
              for (const r of h.list()) n.push(Ee(r, e, t));
              return n.push(c), Ce(n);
            })
            .then(() => {
              n = Re(o, "beforeRouteUpdate", e, t);
              for (const r of o)
                r.updateGuards.forEach((r) => {
                  n.push(Ee(r, e, t));
                });
              return n.push(c), Ce(n);
            })
            .then(() => {
              n = [];
              for (const r of e.matched)
                if (r.beforeEnter && !t.matched.includes(r))
                  if (Array.isArray(r.beforeEnter))
                    for (const o of r.beforeEnter) n.push(Ee(o, e, t));
                  else n.push(Ee(r.beforeEnter, e, t));
              return n.push(c), Ce(n);
            })
            .then(
              () => (
                e.matched.forEach((e) => (e.enterCallbacks = {})),
                (n = Re(a, "beforeRouteEnter", e, t)),
                n.push(c),
                Ce(n)
              )
            )
            .then(() => {
              n = [];
              for (const r of m.list()) n.push(Ee(r, e, t));
              return n.push(c), Ce(n);
            })
            .catch((e) => (G(e, 8) ? e : Promise.reject(e)))
        );
      }
      function K(e, t, n) {
        for (const r of y.list()) r(e, t, n);
      }
      function U(e, t, n, r, o) {
        const c = S(e, t);
        if (c) return c;
        const s = t === M,
          i = l ? history.state : {};
        n &&
          (r || s
            ? a.replace(e.fullPath, u({ scroll: s && i && i.scroll }, o))
            : a.push(e.fullPath, o)),
          (b.value = e),
          Y(e, t, n, s),
          X();
      }
      let V;
      function H() {
        V = a.listen((e, t, n) => {
          const r = C(e),
            o = _(r);
          if (o) return void T(u(o, { replace: !0 }), r).catch(p);
          E = r;
          const c = b.value;
          var s, i;
          l && ((s = j(c.fullPath, n.delta)), (i = O()), x.set(s, i)),
            I(r, c)
              .catch((e) =>
                G(e, 12)
                  ? e
                  : G(e, 2)
                  ? (T(e.to, r)
                      .then((e) => {
                        G(e, 20) &&
                          !n.delta &&
                          n.type === w.pop &&
                          a.go(-1, !1);
                      })
                      .catch(p),
                    Promise.reject())
                  : (n.delta && a.go(-n.delta, !1), Q(e, r, c))
              )
              .then((e) => {
                (e = e || U(r, c, !1)) &&
                  (n.delta
                    ? a.go(-n.delta, !1)
                    : n.type === w.pop && G(e, 20) && a.go(-1, !1)),
                  K(r, c, e);
              })
              .catch(p);
        });
      }
      let W,
        D = be(),
        z = be();
      function Q(e, t, n) {
        X(e);
        const r = z.list();
        return (
          r.length ? r.forEach((r) => r(e, t, n)) : console.error(e),
          Promise.reject(e)
        );
      }
      function X(e) {
        W ||
          ((W = !0),
          H(),
          D.list().forEach(([t, n]) => (e ? n(e) : t())),
          D.reset());
      }
      function Y(n, r, o, a) {
        const { scrollBehavior: c } = e;
        if (!l || !c) return Promise.resolve();
        const s =
          (!o &&
            (function (e) {
              const t = x.get(e);
              return x.delete(e), t;
            })(j(n.fullPath, 0))) ||
          ((a || !o) && history.state && history.state.scroll) ||
          null;
        return t
          .nextTick()
          .then(() => c(n, r, s))
          .then((e) => e && P(e))
          .catch((e) => Q(e, n, r));
      }
      const Z = (e) => a.go(e);
      let J;
      const ee = new Set();
      return {
        currentRoute: b,
        addRoute: function (e, t) {
          let r, o;
          return (
            q(e) ? ((r = n.getRecordMatcher(e)), (o = t)) : (o = e),
            n.addRoute(o, r)
          );
        },
        removeRoute: function (e) {
          const t = n.getRecordMatcher(e);
          t && n.removeRoute(t);
        },
        hasRoute: function (e) {
          return !!n.getRecordMatcher(e);
        },
        getRoutes: function () {
          return n.getRoutes().map((e) => e.record);
        },
        resolve: C,
        options: e,
        push: L,
        replace: function (e) {
          return L(u($(e), { replace: !0 }));
        },
        go: Z,
        back: () => Z(-1),
        forward: () => Z(1),
        beforeEach: h.add,
        beforeResolve: m.add,
        afterEach: y.add,
        onError: z.add,
        isReady: function () {
          return W && b.value !== M
            ? Promise.resolve()
            : new Promise((e, t) => {
                D.add([e, t]);
              });
        },
        install(e) {
          e.component("RouterLink", ke),
            e.component("RouterView", xe),
            (e.config.globalProperties.$router = this),
            Object.defineProperty(e.config.globalProperties, "$route", {
              enumerable: !0,
              get: () => t.unref(b),
            }),
            l &&
              !J &&
              b.value === M &&
              ((J = !0), L(a.location).catch((e) => {}));
          const n = {};
          for (const e in M) n[e] = t.computed(() => b.value[e]);
          e.provide(c, this), e.provide(s, t.reactive(n)), e.provide(i, b);
          const r = e.unmount;
          ee.add(e),
            (e.unmount = function () {
              ee.delete(e),
                ee.size < 1 &&
                  ((E = M), V && V(), (b.value = M), (J = !1), (W = !1)),
                r();
            });
        },
      };
    }),
    (e.createRouterMatcher = N),
    (e.createWebHashHistory = function (e) {
      return (
        (e = location.host
          ? e || location.pathname + location.search
          : "").includes("#") || (e += "#"),
        L(e)
      );
    }),
    (e.createWebHistory = L),
    (e.isNavigationFailure = G),
    (e.matchedRouteKey = o),
    (e.onBeforeRouteLeave = function (e) {
      const n = t.inject(o, {}).value;
      n && we(n, "leaveGuards", e);
    }),
    (e.onBeforeRouteUpdate = function (e) {
      const n = t.inject(o, {}).value;
      n && we(n, "updateGuards", e);
    }),
    (e.parseQuery = ge),
    (e.routeLocationKey = s),
    (e.routerKey = c),
    (e.routerViewLocationKey = i),
    (e.stringifyQuery = ve),
    (e.useLink = Ae),
    (e.useRoute = function () {
      return t.inject(s);
    }),
    (e.useRouter = function () {
      return t.inject(c);
    }),
    (e.viewDepthKey = a),
    Object.defineProperty(e, "__esModule", { value: !0 }),
    e
  );
})({}, Vue);
